import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PromotedBadge } from "@faire/retailer-visitor-shared/features/ADS/PromotedBadge";
import { ProductName } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/ProductName";
import { MaybeProminentPriceFirstSlotter } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductInfo/ProminentPriceFirst/MaybeProminentPriceFirstWrapper";
import { ProductTileSwatches } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/ProductTileSwatches";
import { LazyDebugInfoSection } from "@faire/retailer-visitor-shared/features/MarketplaceItems/MarketplaceProduct/DebugInfo/LazyDebugInfoSection";
import { DiscoveryProductTileBrandInfo, discoveryProductTileBrandInfoParamsILeanProductTileAdapter } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/DiscoveryProductTileBrandInfo";
import { getImage } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/getImage";
import { PriceText } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/PriceText";
import { ProductTileImage } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/ProductTileImage";
import { PRODUCT_TILE_SURFACE, TileImageOverlayContent } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/TileImageOverlayContent";
import { useProductTileViewImpression } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/useProductTileViewImpression";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { assignSettingOnEvent } from "@faire/retailer-visitor-shared/settings/assignSettingOnEvent";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useEffectEvent } from "@faire/web--source/ui/hooks/useEffectEvent";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import { trackEventsUntrackedproducttileView } from "@faire/web-api--source/events/events/view/untrackedproducttile";
import * as React from "react";
import { Suspense, useRef } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
var DiscoveryProductTileProductInfo = function(param) {
    var onLinkClickHandler = param.onLinkClickHandler, productTile = param.productTile, productLinkProps = param.productLinkProps, dataTestId = param["data-test-id"];
    var _productTile_product;
    var _productLinkProps_productUrl, _productTile_product_name;
    return /*#__PURE__*/ _jsxs(Link, {
        onClick: onLinkClickHandler,
        "data-test-id": dataTestId,
        to: (_productLinkProps_productUrl = productLinkProps === null || productLinkProps === void 0 ? void 0 : productLinkProps.productUrl) !== null && _productLinkProps_productUrl !== void 0 ? _productLinkProps_productUrl : "",
        replace: productLinkProps === null || productLinkProps === void 0 ? void 0 : productLinkProps.replace,
        children: [
            /*#__PURE__*/ _jsxs(MaybeProminentPriceFirstSlotter, {
                isPriceFirstSlot: true,
                children: [
                    /*#__PURE__*/ _jsx(PriceText, {
                        productTile: productTile
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "1/2x"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ProductName, {
                productName: (_productTile_product_name = productTile === null || productTile === void 0 ? void 0 : (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.name) !== null && _productTile_product_name !== void 0 ? _productTile_product_name : ""
            }),
            /*#__PURE__*/ _jsx(MaybeProminentPriceFirstSlotter, {
                isPriceFirstSlot: false,
                children: /*#__PURE__*/ _jsx(PriceText, {
                    productTile: productTile
                })
            }),
            /*#__PURE__*/ _jsx(ProductTileSwatches, {
                optionDetails: productTile === null || productTile === void 0 ? void 0 : productTile.options_details
            })
        ]
    });
};
export var DiscoveryProductTile = function(props) {
    var _productTile_product, _productTile_product1, _productTile_product2, _productTile_product3, _brand_insider_label, _productTile_product4, _productTile_product5, _productTile_product6, _productTile_product7;
    var productTile = props.productTile, imageDimension = props.imageDimension, showVerticalImagery = props.showVerticalImagery, brand = props.brand, updateCartFn = props.updateCartFn, disableEventBadge = props.disableEventBadge, generateBrandUrl = props.generateBrandUrl, onBrandLinkClick = props.onBrandLinkClick, onProductLinkClick = props.onProductLinkClick, onHeartClicked = props.onHeartClicked, onSaveToBoard = props.onSaveToBoard, onRemoveFromBoard = props.onRemoveFromBoard, onQuickAdd = props.onQuickAdd, onQuickAddSubmit = props.onQuickAddSubmit, onAuxClick = props.onAuxClick, onChooseOption = props.onChooseOption, onChooseOptionQuantityUpdate = props.onChooseOptionQuantityUpdate, productLinkProps = props.productLinkProps, onTopLeftBadgeVisible = props.onTopLeftBadgeVisible, shouldShowPromotedBadge = props.shouldShowPromotedBadge, altText = props.altText, hideAddToCartAndNotifyMe = props.hideAddToCartAndNotifyMe, recordAdImpression = props.recordAdImpression, shouldHideSaveToBoard = props.shouldHideSaveToBoard, imageBreakpoints = props.imageBreakpoints;
    var retailerToken = useRetailerStore([
        "retailerToken"
    ]).retailerToken;
    var location = useLocation();
    var isLoggedInRetailer = useIsLoggedInRetailer();
    React.useEffect(function() {
        if (!recordAdImpression) {
            var _productTile_product;
            var _productTile_product_token;
            trackEventsUntrackedproducttileView(retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", (_productTile_product_token = productTile === null || productTile === void 0 ? void 0 : (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token) !== null && _productTile_product_token !== void 0 ? _productTile_product_token : "", location.pathname + location.search);
        }
    }, [
        recordAdImpression,
        productTile === null || productTile === void 0 ? void 0 : (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token,
        retailerToken,
        location.pathname,
        location.search
    ]);
    var trackProductTileProps = useProductTileViewImpression({
        productToken: productTile === null || productTile === void 0 ? void 0 : (_productTile_product1 = productTile.product) === null || _productTile_product1 === void 0 ? void 0 : _productTile_product1.token,
        promotedBy: productTile === null || productTile === void 0 ? void 0 : (_productTile_product2 = productTile.product) === null || _productTile_product2 === void 0 ? void 0 : _productTile_product2.promoted_by,
        impressionId: productTile === null || productTile === void 0 ? void 0 : (_productTile_product3 = productTile.product) === null || _productTile_product3 === void 0 ? void 0 : _productTile_product3.impression_id,
        turnOffTracking: !recordAdImpression
    });
    var imageContainerRef = useRef(null);
    var viewport = useViewport();
    var isLoaded = !!productTile;
    var userStore = useUserStore([
        "isEmployee",
        "isImpersonating"
    ]);
    var renderDebugInfoSection = function() {
        var _productTile_product;
        if (!(productTile === null || productTile === void 0 ? void 0 : (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token)) {
            return null;
        }
        if (!(userStore.isEmployee || userStore.isImpersonating)) {
            return null;
        }
        return /*#__PURE__*/ _jsx(Suspense, {
            fallback: null,
            children: /*#__PURE__*/ _jsx(LazyDebugInfoSection, {
                productToken: productTile.product.token,
                promotedBy: productTile.product.promoted_by,
                debugInfo: productTile.retrieval_and_ranking_debug_info
            })
        });
    };
    var settingsAssignmentRef = useDoActionWhenVisible(function() {
        var _productTile_settings_to_assign_on_view;
        productTile === null || productTile === void 0 ? void 0 : (_productTile_settings_to_assign_on_view = productTile.settings_to_assign_on_view) === null || _productTile_settings_to_assign_on_view === void 0 ? void 0 : _productTile_settings_to_assign_on_view.forEach(function(setting) {
            assignSettingOnEvent(setting);
        });
    });
    var onLinkClickHandler = useEffectEvent(function(ev) {
        if (productTile) {
            onProductLinkClick === null || onProductLinkClick === void 0 ? void 0 : onProductLinkClick(productTile, ev);
        }
    });
    var insiderBadgeProps = {
        insiderBenefits: brand === null || brand === void 0 ? void 0 : brand.insider_benefits,
        insiderLabelText: brand === null || brand === void 0 ? void 0 : (_brand_insider_label = brand.insider_label) === null || _brand_insider_label === void 0 ? void 0 : _brand_insider_label.text
    };
    var brandInfoComponent = brand == null ? null : /*#__PURE__*/ _jsx(DiscoveryProductTileBrandInfo, {
        brand: discoveryProductTileBrandInfoParamsILeanProductTileAdapter(brand),
        isLoggedInRetailer: isLoggedInRetailer,
        onBrandLinkClick: onBrandLinkClick,
        generateBrandUrl: generateBrandUrl,
        "data-test-id": props["data-test-id"],
        productLinkProps: productLinkProps,
        isLoaded: isLoaded,
        insiderBadgeProps: insiderBadgeProps,
        avgBrandReviewRating: productTile === null || productTile === void 0 ? void 0 : (_productTile_product4 = productTile.product) === null || _productTile_product4 === void 0 ? void 0 : _productTile_product4.avg_brand_review_rating,
        brandReviewCount: productTile === null || productTile === void 0 ? void 0 : (_productTile_product5 = productTile.product) === null || _productTile_product5 === void 0 ? void 0 : _productTile_product5.brand_review_count,
        brandPromoText: productTile === null || productTile === void 0 ? void 0 : productTile.brand_promo_text,
        isHighlightedProductForPromotionalEvent: productTile === null || productTile === void 0 ? void 0 : productTile.is_highlighted_product_for_promotional_event,
        onLinkClickHandler: onLinkClickHandler
    });
    var _props_datatestid, _props_datatestid1, _productLinkProps_productUrl;
    return(// trackProductTileProps should ALWAYS wrap the outermost div of the product tile
    /*#__PURE__*/ _jsx(Container, _object_spread_props(_object_spread({}, trackProductTileProps), {
        onAuxClick: onAuxClick,
        ref: function(element) {
            var _trackProductTileProps_ref;
            trackProductTileProps === null || trackProductTileProps === void 0 ? void 0 : (_trackProductTileProps_ref = trackProductTileProps.ref) === null || _trackProductTileProps_ref === void 0 ? void 0 : _trackProductTileProps_ref.call(trackProductTileProps, element);
            settingsAssignmentRef(element);
        },
        children: /*#__PURE__*/ _jsxs("div", {
            id: "product-tile-".concat(productTile === null || productTile === void 0 ? void 0 : (_productTile_product6 = productTile.product) === null || _productTile_product6 === void 0 ? void 0 : _productTile_product6.token),
            "data-test-id": isLoaded ? (_props_datatestid = props["data-test-id"]) !== null && _props_datatestid !== void 0 ? _props_datatestid : "product-tile" : "product-tile-placeholder",
            children: [
                /*#__PURE__*/ _jsxs(ProductTileImage, {
                    productToken: productTile === null || productTile === void 0 ? void 0 : (_productTile_product7 = productTile.product) === null || _productTile_product7 === void 0 ? void 0 : _productTile_product7.token,
                    image: getImage(productTile),
                    "data-test-id": (_props_datatestid1 = props["data-test-id"]) !== null && _props_datatestid1 !== void 0 ? _props_datatestid1 : "product-tile-link",
                    imageAltText: altText,
                    onClick: onLinkClickHandler,
                    showVerticalImagery: showVerticalImagery,
                    imageContainerRef: imageContainerRef,
                    imageDimension: imageDimension,
                    imageBreakpoints: imageBreakpoints,
                    productLinkProps: productLinkProps,
                    children: [
                        /*#__PURE__*/ _jsx(TileImageOverlayContent, {
                            imageContainerRef: imageContainerRef,
                            productTile: productTile,
                            updateCartFn: updateCartFn,
                            disableEventBadge: disableEventBadge,
                            onTopLeftBadgeVisible: onTopLeftBadgeVisible,
                            renderCollapsableQuickAddButtonProps: props.renderCollapsableQuickAddButtonProps,
                            onHeartClicked: onHeartClicked,
                            onSaveToBoard: onSaveToBoard,
                            onQuickAdd: onQuickAdd,
                            onQuickAddSubmit: onQuickAddSubmit,
                            onRemoveFromBoard: onRemoveFromBoard,
                            onChooseOption: onChooseOption,
                            onChooseOptionQuantityUpdate: onChooseOptionQuantityUpdate,
                            hideAddToCartAndNotifyMe: hideAddToCartAndNotifyMe,
                            shouldHideSaveToBoard: shouldHideSaveToBoard,
                            productTileSurface: PRODUCT_TILE_SURFACE.DISCOVERY
                        }),
                        renderDebugInfoSection()
                    ]
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    size: viewport.isMobile ? "1x" : 12
                }),
                /*#__PURE__*/ _jsxs(Column, {
                    gap: viewport.isMobile ? 2 : 4,
                    children: [
                        /*#__PURE__*/ _jsx(DiscoveryProductTileProductInfo, {
                            productTile: productTile,
                            productLinkProps: productLinkProps,
                            "data-test-id": props["data-test-id"],
                            onLinkClickHandler: onLinkClickHandler
                        }),
                        viewport.isMobile ? null : /*#__PURE__*/ _jsx(Spacer, {
                            size: "1/4x"
                        }),
                        brandInfoComponent,
                        shouldShowPromotedBadge ? /*#__PURE__*/ _jsx(Link, {
                            onClick: onLinkClickHandler,
                            "data-test-id": props["data-test-id"],
                            to: (_productLinkProps_productUrl = productLinkProps === null || productLinkProps === void 0 ? void 0 : productLinkProps.productUrl) !== null && _productLinkProps_productUrl !== void 0 ? _productLinkProps_productUrl : "",
                            replace: productLinkProps === null || productLinkProps === void 0 ? void 0 : productLinkProps.replace,
                            children: /*#__PURE__*/ _jsx(PromotedBadge, {
                                noPadding: true
                            })
                        }) : null
                    ]
                })
            ]
        })
    })));
};
var Container = styled.div.withConfig({
    componentId: "sc-99c74a2b-0"
})([
    "position:relative;"
]);
